import React, { Component } from 'react';
import { connect } from 'react-redux';

import { NavLink, withRouter } from 'react-router-dom';

import logo from '../../assets/images/logos/Logo-Color@2x.png';

import {
  isProduction,
  currentUserRole,
} from '../../util';
import { getIcon } from '../../util/icons';

class Header extends Component {

  showMinimalHeader(){
    const userRole = currentUserRole();
    return userRole !== 'manager' && userRole !== 'admin' && userRole !== 'salesleader' && userRole !== 'superadmin' && userRole !== '';
  }

  renderNavigation(){

    const userRole = currentUserRole();
    const showMinimalHeader = this.showMinimalHeader();

    if(!userRole){
      return null;
    }

    return (
      <ul className="navigation">

        {!showMinimalHeader && userRole === 'manager' &&
          <li><NavLink to="/teams">My Team</NavLink></li>
        }
        {!showMinimalHeader && userRole === 'manager' && !isProduction() &&
          <li><NavLink to="/deals">Deals</NavLink></li>
        }
        {/*Disable manager "my profile" view for now*/}
        {!showMinimalHeader && userRole === 'manager' && false &&
          <li><NavLink to="/sprint">My Profile</NavLink></li>
        }
        {!showMinimalHeader && (userRole === 'admin' || userRole === 'superadmin') &&
          <li><NavLink to="/people">People</NavLink></li>
        }
        {!showMinimalHeader && userRole !== 'manager' &&
          <li><NavLink to="/all-teams">Teams</NavLink></li>
        }
        {!showMinimalHeader &&
          <li><NavLink to="/resources">Resources</NavLink></li>
        }
        {!showMinimalHeader && userRole !== 'manager' &&
          <li><NavLink to="/reports">Reports</NavLink></li>
        }
        {!showMinimalHeader && userRole !== 'manager' &&
          <li><NavLink to="/insights">Insights</NavLink></li>
        }

        {!showMinimalHeader && userRole !== 'manager' &&
          <li><NavLink to="/settings">{getIcon('settings')}</NavLink></li>
        }
        {!showMinimalHeader && userRole === 'manager' &&
          <li><NavLink to="/profile">{getIcon('settings')}</NavLink></li>
        }


        <li><NavLink to="/logout">{getIcon('logout')}</NavLink></li>

      </ul>
    )
  }

  renderHeaderLogo(){
    const userRole = currentUserRole();

    const linkForHeader = (userRole === 'employee' ? '/sprint' :
                          (userRole === 'manager' ? '/teams' :
                          (userRole === 'salesleader' ? '/all-teams' :
                          (userRole === 'admin' ? '/people' :
                          '/organizations'))));

    return (
      <NavLink to={linkForHeader}>
        <img className="logo" src={logo} alt="Velocity" />
      </NavLink>
    );
  }

  renderOrganizationsDropdownIfSuperAdmin(){
    const userRole = currentUserRole();

    if(userRole !== 'superadmin'){
      return null;
    }

    return (
      <div className="organization-dropdown">
        <NavLink to="/organizations"><span>Viewing: {(this.props.organization || {}).name}</span>{getIcon('organization')}</NavLink>
      </div>
    )
  }

  render(){
    const showMinimalHeader = this.showMinimalHeader();

    return (
      <header className={showMinimalHeader ? 'minimal' : ''}>
        <div className="content-wrapper">
          {this.renderHeaderLogo()}
          {this.renderOrganizationsDropdownIfSuperAdmin()}
          {this.renderNavigation()}
        </div>
      </header>
    )
  }
}

function mapStateToProps(state, ownProps){
  //https://github.com/reactjs/react-router-redux#how-do-i-access-router-state-in-a-container-component
  return {
    user: state.user,
    route: ownProps.location.pathname,
    organization: state.organization.data,
  }
}

export default withRouter(connect(mapStateToProps, {})(Header));



// WEBPACK FOOTER //
// ./src/components/header/index.js